
import { apiRequest } from '../../apiCall'
import { GetCustomerAttachment, GetResponseCustomerAttachment, SaveCustomerAttachment } from '../../types/customerAttachments/apiRequestType'

export const saveCustomerAttachmentsRequest = (params: SaveCustomerAttachment) =>  apiRequest('CustomerAttachment.Save', params, '', false) 
export const getCustomerAttachmentsRequest = (id: GetCustomerAttachment) => apiRequest('CustomerAttachment.GetCustomerAttachments', { id }, '', false)
export const deleteCustomerAttachmentsRequest = (params: GetResponseCustomerAttachment) => apiRequest('CustomerAttachment.Delete', params, '', false)
export const getCustomerAttachmentByIdRequest = (id: string) => apiRequest('CustomerAttachment.getCustomerAttachmentById',id, '', false)

